import React from 'react';
import PropTypes from 'prop-types';
import Card from '@lightspeed/cirrus-card';
import Text from '@lightspeed/cirrus-text';

const Table = ({ headings, rows }) => (
  <Card>
    <table className="retail-table">
      <thead className="retail-table__heading">
        <tr>
          {headings.map((heading, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <th key={`heading_${index}`}>
              <Text bodySmall bold>
                {heading}
              </Text>
            </th>
          ))}
        </tr>
      </thead>
      <tbody className="retail-table__body">
        {rows.map((row, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <tr key={`row_${index}`}>
            {row.map((column, columnIndex) => (
              // eslint-disable-next-line react/no-array-index-key
              <td key={`column_${index}_${columnIndex}`}>{column}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </Card>
);

Table.propTypes = {
  headings: PropTypes.arrayOf(PropTypes.node),
  rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)),
};

Table.defaultProps = {
  headings: [],
  rows: [[]],
};

export default Table;
